import { useMutation } from 'react-query';

import { FlashMessageParams, setFlashMessage } from '../utils/backend-api/flash';

// Only use this if redirect from React Component to rails page
// Otherwise use React Toast library.
export default function useCreateFlash(redirectUrl: string) {
  const { mutate, mutateAsync, data, isLoading, isError } = useMutation(
    (params: FlashMessageParams) => setFlashMessage(params),
    {
      onSuccess: () => {
        window.location.href = redirectUrl;
      },
    }
  );
  return { mutate, mutateAsync, data, isLoading, isError };
}
